module.exports = __webpack_public_path__ + "static/img/ppt-page.d1f20c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppt-page.jpg
// module id = Ejph
// module chunks = 1